// tslint:disable
export var AgencyType;
(function (AgencyType) {
    // NatlHealthAgncy
    AgencyType[AgencyType["NatlHealthAgncy"] = 59] = "NatlHealthAgncy";
    // IndlHealthAgncy
    AgencyType[AgencyType["IndlHealthAgncy"] = 60] = "IndlHealthAgncy";
    // PDCI
    AgencyType[AgencyType["PDCI"] = 62] = "PDCI";
})(AgencyType || (AgencyType = {}));
AgencyType['NATLHEALTHAGNCY'] = 59;
AgencyType['INDLHEALTHAGNCY'] = 60;
//# sourceMappingURL=AgencyType.js.map